import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { withPagination } from '@ngneat/elf-pagination';
import { GridSortItem } from '@mui/x-data-grid-pro';

import { History, HistoryFilters } from '@store/settings/history/history.model';
import { TablePagination } from '@store/common/pagination.model';
import { TableConfig } from '@constants/table.constants';

export interface HistoriesState {
  filters: HistoryFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  history?: History;
}

export const historiesStore = createStore(
  { name: 'histories' },
  withProps<HistoriesState>({
    filters: { search: '', tableFilters: HistoryFilters.initTableFilters() },
    sort: {
      field: 'updatedAt',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<History>(),
  withPagination(),
  withRequestsStatus()
);
